<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6NGrmf/tc-custom/9780226147697.jpg?1737166238620" alt="This image is the cover for the book History of Religious Ideas Volume 1, A History of Religious Ideas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">History of Religious Ideas Volume 1, A History of Religious Ideas
      </h1>
      <p class="bookDescription body article font2">
        <b>“Everyone who cares about the human adventure will find new information and new angles of vision.”—Martin E. Marty, <i>The New York Times Book Review</i></b><br/>  <br/> This extraordinary work delves into the subject of religion in the prehistoric and ancient worlds—humankind’s earliest quests for meaning. From Neanderthal burials to the mythology of the Iron Age, to the religions of Mesopotamia, Egypt, Greece, Israel, India, and beyond, it offers both an appreciation of the wide-ranging diversity of religious expression—and a consideration of the fundamental unity of religious phenomena.<br/>  <br/> “Will arouse the interest of all historians of western religion, since it includes chapters on the religions of Canaan and Israel. However, the book must be read cover to cover if one wants to grasp the significance of its gigantic historical scope.”—<i>Church History</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mircea Eliade, Willard R. Trask
      </h2>
      
      <p class="authorDescription body article">Mircea Eliade (1907-1986) was the Sewell L. Avery Distinguished Service Professor at the Divinity School and professor in the Committee on Social Thought at the University of Chicago. He was one of the most influential scholars of religion of the 20th century and one of the world's foremost interpreters of religious symbolism and myth. Eliade was the author of many works of scholarship and fiction, including A History of Religious Ideas and ten novels.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4028dc11